import React, { Component } from "react";
import { Row, Col, Image, Button } from "react-bootstrap";
import months from "../../../src/util/months";



export default class EventCard extends Component {
    render() {
        let tab;
        if (new Date(this.props.event.end_date) < new Date()) {
            tab = <div className="tab past">Past event</div>;
        } else {
            switch (this.props.event.purpose) {
            case "networking":
                tab = <div className="tab networking">Upcoming networking event</div>;
                break;
            case "inauguration":
                tab = <div className="tab inauguration">Upcoming inauguration event</div>;
                break;
            }
        }

        return (
            <Row>
                <Col md={12}>
                    <div className="event">
                        {tab}
                        <Row>
                            <Col md={7} className="left-content">
                                <div>
                                    <Image src={this.props.event.fingerprinted_image} responsive />
                                    <div className="controls">
                                      <Button href={this.props.event.hyperlink} target="_blank">Go to event website</Button>
                                    </div>
                                </div>
                            </Col>
                            <Col md={5} className="right-content">
                                <h3>{this.props.event.name}</h3>
                                <div className="date">{this.props.event.date_range}</div>

                                <p dangerouslySetInnerHTML={{ __html: this.props.event.description }}></p>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/EventCard.jsx.erb